<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'APP',
  created() {},
  provide() {
    return {
      reload: this.reload,
      getIsWap: () => this.isWap,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isWap: false,
    };
  },
  created() {
    this.winResize();
    window.addEventListener('resize', this.winResize);
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    winResize() {
      this.isWap = window.innerWidth <= 750;
      const className = this.isWap ? 'wap': '';
      document.documentElement.className = className;
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  background-color: #fff;
}
#app {
  background-color: #fff;
}

::-webkit-scrollbar {
  width: 4px;
  height: 2px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
</style>
